import React from "react";

/**
 * Set de íconos del rediseño: trazo de 1.6, grilla de 24, currentColor.
 * Nada de emoji ni dingbats como ícono — todo SVG para que escale y recoloree.
 */
const Svg = ({ size = 18, strokeWidth = 1.6, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

export const IconDashboard = (p) => (
  <Svg {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </Svg>
);

export const IconOrders = (p) => (
  <Svg {...p}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5" />
    <path d="M9 13h6M9 17h4" />
  </Svg>
);

export const IconClients = (p) => (
  <Svg {...p}>
    <path d="M16 20v-1.5A3.5 3.5 0 0 0 12.5 15h-5A3.5 3.5 0 0 0 4 18.5V20" />
    <circle cx="10" cy="8" r="3.2" />
    <path d="M20 20v-1.5a3.5 3.5 0 0 0-2.6-3.4" />
    <path d="M15.5 5.2a3.2 3.2 0 0 1 0 5.6" />
  </Svg>
);

export const IconBilling = (p) => (
  <Svg {...p}>
    <path d="M6 3h12v18l-2.5-1.6L13 21l-2.5-1.6L8 21l-2-1.3z" />
    <path d="M9 8h6M9 12h6" />
  </Svg>
);

export const IconAccounts = (p) => (
  <Svg {...p}>
    <path d="M3 20h18" />
    <rect x="5" y="11" width="3.5" height="6" rx="1" />
    <rect x="10.5" y="6" width="3.5" height="11" rx="1" />
    <rect x="16" y="13" width="3.5" height="4" rx="1" />
  </Svg>
);

export const IconWallet = (p) => (
  <Svg {...p}>
    <path d="M3 8.5A2.5 2.5 0 0 1 5.5 6H19a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5.5A2.5 2.5 0 0 1 3 16.5z" />
    <path d="M3 8.5V7a2 2 0 0 1 2-2h11" />
    <circle cx="17" cy="12.5" r="1.2" />
  </Svg>
);

export const IconCheck = (p) => (
  <Svg {...p}>
    <rect x="2.5" y="6" width="19" height="12" rx="2" />
    <circle cx="12" cy="12" r="2.5" />
    <path d="M6 12h.01M18 12h.01" />
  </Svg>
);

export const IconReport = (p) => (
  <Svg {...p}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5" />
    <path d="M9 17v-3M12 17v-5M15 17v-2" />
  </Svg>
);

export const IconSidebarToggle = (p) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M9.5 4v16" />
  </Svg>
);

export const IconSun = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M18.8 5.2l-1.4 1.4M6.6 17.4l-1.4 1.4" />
  </Svg>
);

export const IconMoon = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M20 13.5A8 8 0 1 1 10.5 4a6.5 6.5 0 0 0 9.5 9.5z" />
  </Svg>
);

export const IconMonitor = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <rect x="3" y="4.5" width="18" height="12" rx="2" />
    <path d="M9 20h6M12 16.5V20" />
  </Svg>
);

export const IconEye = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
    <circle cx="12" cy="12" r="3.2" />
  </Svg>
);

export const IconMail = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <rect x="3" y="5.5" width="18" height="13" rx="2" />
    <path d="M3.6 6.6 12 12.8l8.4-6.2" />
  </Svg>
);

export const IconMoney = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M14.4 9.4a2.6 2.6 0 0 0-2.4-1.4c-1.4 0-2.4.8-2.4 1.9 0 2.6 5 1.3 5 3.9 0 1.1-1.1 1.9-2.6 1.9a2.7 2.7 0 0 1-2.5-1.5" />
    <path d="M12 6.4v11.2" />
  </Svg>
);

export const IconTrend = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M3 17l6-6 4 4 8-8" />
    <path d="M14 7h7v7" />
  </Svg>
);

export const IconPlus = (p) => (
  <Svg strokeWidth={2} {...p}>
    <path d="M12 5v14M5 12h14" />
  </Svg>
);

export const IconSearch = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M20 20l-3.6-3.6" />
  </Svg>
);

export const IconBell = (p) => (
  <Svg {...p}>
    <path d="M18 9a6 6 0 1 0-12 0c0 5-2 6-2 6h16s-2-1-2-6" />
    <path d="M13.7 20a2 2 0 0 1-3.4 0" />
  </Svg>
);

export const IconChevronRight = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M9 6l6 6-6 6" />
  </Svg>
);

export const IconArrowRight = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M4 12h15" />
    <path d="M13 6l6 6-6 6" />
  </Svg>
);

export const IconChevronLeft = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M15 6l-6 6 6 6" />
  </Svg>
);

export const IconChevronDown = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);

export const IconArrowUpRight = (p) => (
  <Svg strokeWidth={1.9} {...p}>
    <path d="M7 17L17 7M9 7h8v8" />
  </Svg>
);

export const IconClock = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 1.8" />
  </Svg>
);

export const IconAlert = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M12 4.5 21 19.5H3z" />
    <path d="M12 10v4M12 17h.01" />
  </Svg>
);

export const IconMoneyIn = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M12 20V5" />
    <path d="M6.5 10.5 12 5l5.5 5.5" />
    <path d="M4 21h16" />
  </Svg>
);

export const IconMoneyOut = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M12 4v15" />
    <path d="M6.5 13.5 12 19l5.5-5.5" />
    <path d="M4 21h16" />
  </Svg>
);

export const IconLogout = (p) => (
  <Svg {...p}>
    <path d="M15 17l5-5-5-5" />
    <path d="M20 12H9" />
    <path d="M12 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6" />
  </Svg>
);

export const IconHome = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M4 11.2 12 4l8 7.2" />
    <path d="M6 10v10h12V10" />
  </Svg>
);

export const IconMenu = (p) => (
  <Svg {...p}>
    <path d="M4 6h16M4 12h16M4 18h16" />
  </Svg>
);

export const IconFilter = (p) => (
  <Svg {...p}>
    <path d="M4 6h16M7 12h10M10 18h4" />
  </Svg>
);

export const IconCalendar = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <rect x="3.5" y="5" width="17" height="15" rx="2" />
    <path d="M3.5 10h17M8 3.5v3M16 3.5v3" />
  </Svg>
);

export const IconPen = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <path d="M15.5 5.5l3 3" />
    <path d="M4 20l1-4 11-11 3 3-11 11z" />
  </Svg>
);

export const IconCamera = (p) => (
  <Svg {...p}>
    <path d="M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
    <circle cx="12" cy="13" r="3.2" />
  </Svg>
);

export const IconCheckCircle = (p) => (
  <Svg strokeWidth={1.7} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M8.5 12.3l2.4 2.4 4.6-4.9" />
  </Svg>
);

export const IconClose = (p) => (
  <Svg strokeWidth={1.8} {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Svg>
);

/** Isotipo de la marca, tomado de src/assets/iso.svg. */
export const BrandMark = ({ size = 17 }) => (
  <svg
    width={size}
    height={(size * 111.031) / 126.893}
    viewBox="0 0 126.893 111.031"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M35.689,0h91.2V71.377h-91.2A35.689,35.689,0,1,1,35.689,0Z" fill="#676767" />
    <path
      d="M0,0H91.2a35.689,35.689,0,1,1,0,71.377H0Z"
      transform="translate(0 39.654)"
      fill="rgba(255,0,0,0.82)"
    />
  </svg>
);
